import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.innerNumberClass),
      style: _normalizeStyle(_ctx.innerNumberStyle)
    }, _toDisplayString(_ctx.percentage), 7),
    _createTextVNode(),
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.innerUnitClass),
      style: _normalizeStyle(_ctx.innerUnitStyle)
    }, "\n      %\n    ", 6)
  ]))
}